import { fetchRefreshToken } from '@src/core/api/fetch-refresh-token';
import { useAuthStore } from '@src/core/store/auth-store';
import React, { useLayoutEffect } from 'react';
import { PUBLIC_PATH } from '../paths';
import { useNavigate } from 'react-router-dom';

export function AuthGuard({
  shouldRedirectToLogin = true,
  children,
}: {
  shouldRedirectToLogin?: boolean;
  children: React.ReactNode;
}) {
  const { accessToken } = useAuthStore();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (accessToken) return;

    const refreshToken = async () => {
      const newAccessToken = await fetchRefreshToken();
      if (newAccessToken) {
        useAuthStore.getState().setAccessToken(newAccessToken);
      } else {
        if (shouldRedirectToLogin) {
          navigate(PUBLIC_PATH.LOGIN, { replace: true });
        }
      }
    };

    refreshToken();
  }, [accessToken, shouldRedirectToLogin, navigate]);

  return <>{children}</>;
}
